module.exports = __webpack_public_path__ + "img/Blog-Image@2x.3b8cbf6e.png";